import { render, staticRenderFns } from "./LatestCodeDisplay.html?vue&type=template&id=54625516&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./LatestCodeDisplay.scss?vue&type=style&index=0&id=54625516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54625516",
  null
  
)

export default component.exports